<template>
  <Layout>
    <div class="row" v-if="userData.permissions['school_mgt'] == 1">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body" v-for="item in profiles" :key="item.id">
            <form @submit.prevent="UpdateProfile">
              <div class="row">
                <div class="col-lg-6">
                  <div class="form-group mb-2">
                    <b-form-group label="Facility Name" description="name">
                      <input
                        :value="item.name"
                        type="text"
                        readonly
                        style="background: none;"
                        class="form-control text-primary"
                      />
                    </b-form-group>
                  </div>
                  <div class="form-group mb-2">
                    <b-form-group label="Address" description="location">
                      <input
                        :value="item.location"
                        type="text"
                        readonly
                        style="background: none;"
                        class="form-control text-primary"
                      />
                    </b-form-group>
                  </div>
                  <div class="form-group mb-2">
                    <b-form-group label="Telephone" description="contact">
                      <input
                        :value="item.telephone"
                        type="text"
                        readonly
                        style="background: none;"
                        class="form-control text-primary"
                      />
                    </b-form-group>
                  </div>
                  <div class="form-group mb-2">
                    <b-form-group label="Email Address" description="email">
                      <input
                        :value="item.email"
                        type="text"
                        readonly
                        style="background: none;"
                        class="form-control text-primary"
                      />
                    </b-form-group>
                  </div>
                  <div class="form-group mb-2">
                    <b-form-group label="School Motto" description="motto">
                      <input
                        :value="item.motto"
                        type="text"
                        readonly
                        style="background: none;"
                        class="form-control text-primary"
                      />
                    </b-form-group>
                  </div>
                </div>

                <div class="col-lg-6">
                  <div class="form-group mb-2">
                    <b-form-group label="SMS Balance" description="sms">
                      <input
                        :value="item.sms_balance"
                        type="text"
                        readonly
                        style="background: none;"
                        class="form-control text-primary"
                      />
                    </b-form-group>
                  </div>
                  <div class="form-group mb-2">
                    <b-form-group label="Facility Logo" description="logo">
                      <input
                        type="file"
                        class="form-control"
                        v-on:change="onLogoChange"
                      />
                    </b-form-group>
                  </div>
                  <span v-if="item.logo != 0">
                    <img :src="getFiles(item.logo)" height="100px" />
                  </span>
                  <span v-else>
                    <img src="@/assets/images/logo.png" height="100px" />
                  </span>
                  <div class="form-group mb-2">
                    <b-form-group
                      label="Next Term begins on"
                      description="Start date"
                    >
                      <input
                        :value="item.next_term"
                        type="date"
                        :min="date"
                        style="background: none;"
                        class="form-control text-primary"
                      />
                    </b-form-group>
                  </div>
                </div>
                <div class="form-group">
                  <br />
                  <b-button type="submit" class="btn w-100" variant="primary"
                    ><i class="fas fa-check-circle"></i> Update</b-button
                  >
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
            <center>
              <span class="text-primary h6"
                >You have no permission to view Facility Profile</span
              >
            </center>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { profileMethods, profileComputed } from "@/state/helpers";

export default {
  page: {
    title: "School Profile",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      logo: "",
      next_term: "",
      motto: "",
      date: new Date().toLocaleDateString("fr-CA"),
    };
  },
  methods: {
    ...profileMethods,
    onLogoChange(e) {
      this.logo = e.target.files[0];
    },
    getFiles(name) {
      let url = axios.defaults.baseURL;
      let imagelink = url.slice(0, -3) + "logos/" + name;
      return imagelink;
    },
    async UpdateProfile() {
      const config = { headers: { "content-type": "multipart/form-data" } };
      let formData = new FormData();
      formData.append("logo", this.logo);
      formData.append("next_term", this.next_term);
      let url = "/updateprofile";
      await axios.post(url, formData, config).then((response) => {
        if (response.status == 200) {
          this.fetchProfile();
          this.logo = "";
          this.$toast.success(response.data.message);
        }
      });
    },
  },
  computed: {
    ...profileComputed,
  },
  mounted() {
    this.fetchProfile();
  },
};
</script>
